import { Chip, Stack } from '@mui/material'

/**
 * Type des sources supportées (miroir de SourceMetadata['type'] dans
 * @data-agents/database). Gardé local pour éviter une dépendance lourde.
 */
type ProposalSourceType =
  | 'URL'
  | 'IMAGE'
  | 'TEXT'
  | 'SLACK'
  | 'FFA'
  | 'GOOGLE'
  | 'EVENT_PAGE'

interface ProposalSourceChipProps {
  source: ProposalSourceType | string | null | undefined
  /** Optional Miles env tag — 'staging', 'preview-xyz' show a warning chip
   *  next to the source label. 'prod' or undefined render nothing extra. */
  milesEnv?: string | null
}

/**
 * Petit Chip MUI affichant la source d'une proposition.
 * - SLACK     -> "Slack"     (color="info")
 * - EVENT_PAGE-> "Page Event" (color="secondary")
 * - autres    -> label brut (variant="outlined")
 *
 * Quand milesEnv est non-prod, ajoute un chip "staging" / etc. à côté.
 */
export function ProposalSourceChip({ source, milesEnv }: ProposalSourceChipProps) {
  const envChip =
    milesEnv && milesEnv !== 'prod' ? (
      <Chip label={milesEnv} color="warning" size="small" variant="outlined" />
    ) : null

  const sourceChip = (() => {
    if (source === 'SLACK') return <Chip label="Slack" color="info" size="small" />
    if (source === 'EVENT_PAGE') return <Chip label="Page Event" color="secondary" size="small" />
    return <Chip label={source ?? 'Unknown'} variant="outlined" size="small" />
  })()

  if (!envChip) return sourceChip
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      {sourceChip}
      {envChip}
    </Stack>
  )
}
